import React, { Component } from 'react';
import image from '../../assets/img/vector/control_acceso.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import imgBody1 from '../../assets/img/contenido/vigilancia.png';
import imgBody2 from '../../assets/img/contenido/hikvision1.jpg';
import hikvision from '../../assets/img/brand/hikvision.png';
import img1 from '../../assets/img/flat/cacceso1.svg';
import img2 from '../../assets/img/flat/cacceso2.svg';
import img3 from '../../assets/img/flat/cacceso3.svg';
import IconBlock from '../../subcomponents/IconBlock28';
class ControlDeAcceso extends Component {
  componentDidMount() {
    document.title = 'Control de Acceso - Insacom';
  }
  render() {
    const content = [
      {
        id: 1,
        title: 'Seguridad',
        description: 'Control de acceso a lugares restringidos',
        img: img1
      },
      {
        id: 2,
        title: 'Gestión Centralizada',
        description: 'Administre usuarios, horarios y permisos, todo desde un sólo lugar',
        img: img2
      },
      {
        id: 3,
        title: 'Control',
        description: 'Revise el detalle de los eventos de ingreso a sus dependencias',
        img: img3
      }
    ];
    const descripcion =
      'Cumpla con las últimas certificaciones internacionales en Calidad y seguridad. Cuente con la información precisa de las personas que acceden a sus edificios, sucursales y oficinas.';
    return (
      <Section asuntoContacto={'Control de Acceso'}>
        <SectionContainer grey paddingBottom={'0px'}>
          <ImageText image={image} title="Control de Acceso" description={descripcion}>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="align-self-center">
                <img src={hikvision} alt="HIKVISION" style={{ height: '65px', paddingBottom: 20 }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={imgBody1}
            title="Características"
            description="Control de todos los accesos de la empresa.">
            <ul className="list-unstyled mb-0">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Solución IP, se integra fácilmente con su red actual.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Acceso mediante biometría y tarjetas de proximidad.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Base de datos centralizada de usuarios.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Solución escalable, permite conectar múltiples sitios mediante red IP.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
        <SectionContainer>
          <ImageText image={imgBody2}>
            <p className="lead">
              También es posible integrar accesos vehiculares con la tecnología de reconocimiento de
              placas LPR, la cual permite la comparación en tiempo real de los datos del vehículo y
              ajecutar acciones automatizadas sobre otros dispositivos de control o de vigilancia.
            </p>
          </ImageText>
        </SectionContainer>
      </Section>
    );
  }
}

export default ControlDeAcceso;



// WEBPACK FOOTER //
// ./src/sections/proyectos/ControlDeAcceso.js